import { render } from "./PanelUser.vue?vue&type=template&id=dac6f936"
import script from "./PanelUser.vue?vue&type=script&lang=js"
export * from "./PanelUser.vue?vue&type=script&lang=js"

import "./PanelUser.vue?vue&type=style&index=0&id=dac6f936&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__